import ReactDOM from "react-dom/client";
//import React from "react";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Switch, Route, Routes, Link } from "react-router-dom";

import logo from './logo.svg';
import { UserAuthContextProvider } from "./context/UserAuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PhoneSingnUp from "./components/auth/PhoneSignup";
import CmList from './components/cm/CmList';
import Teigi from './components/cm/Teigi'
import Settings from "./components/cm/Settings";

import Hello from './components/Hello';
import Top from './components/Top';
import Everyone from "./components/cm/Everyone";
import Orverseas from "./components/orverseas/Orverseas";

import './App.css';



function App() {
  const [adamin_member, setAdaminMember] = useState([]);
  //const [first_loadding, setFirstLoading] = useState(true);

  useEffect(() => {
    setAdaminMember(['川畑美穂','坂本　彰', '大島']);
    //setFirstLoading(false);

    let url_pathname = window.location.pathname;
    if(url_pathname.indexOf('cm-list') === -1){ //なければ
      document.getElementById('first-loading').style.display='none'; //index.html内 読み込み中の文字を消す処理
    }
    // cm-list の場合は, CmList.js ないで処理

  
  }, []);


  return (
    <div className="App_1">
      <BrowserRouter>
        {/* {  first_loadding ? (<div className="text-danger" >読み込み中...</div>) : (<></>)} */}
        <UserAuthContextProvider>
          <Routes>
            
            <Route path="/login" element={<PhoneSingnUp />} />
            <Route path="/cm-list" element={<ProtectedRoute><CmList adamin_member={adamin_member} /></ProtectedRoute>} />
            <Route path="/cm-list-teigi" element={<ProtectedRoute><Teigi /></ProtectedRoute>} />
            <Route path="/cm-list-settings" element={<ProtectedRoute><Settings adamin_member={adamin_member} /></ProtectedRoute>} />

            <Route path="/hello" element={<ProtectedRoute><Hello /></ProtectedRoute>} />
            
          </Routes>

        </UserAuthContextProvider>

        <Routes>
          <Route path="/" element={<Top />} />
          <Route path="/cm-everyone" element={<Everyone />} />
          <Route path="/orverseas" element={<Orverseas />} />
        </Routes>
      </BrowserRouter>


      
    </div>
  );
}

export default App;


